export enum OrganizationStatus {
  Active = 'active',
  Canceled = 'canceled',
  Creating = 'creating',
}
